import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { db, functions } from '../firebaseConfig'
import { collection, getDocs } from 'firebase/firestore'
import { httpsCallable } from 'firebase/functions'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Select from 'react-select'
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useTheme } from '../context/ThemeContext'

const ManageUser = () => {
    const { theme } = useTheme()
    const isDark = theme === 'dark'
    const [users, setUsers] = useState([])
    const [searchTerm, setSearchTerm] = useState('')
    const [currentPage, setCurrentPage] = useState(1)
    const [filters, setFilters] = useState({
        posisi: '',
        unit: '',
        role: '',
        department: '',
        lokasi: ''
    })
    const itemsPerPage = 10 // Jumlah item per halaman
    const navigate = useNavigate()
    const [loading, setLoading] = useState(true)
    const [deleteModal, setDeleteModal] = useState({ isOpen: false, user: null })
    const [isDeleting, setIsDeleting] = useState(false)

    const filterOptions = {
        posisi: [
            { value: 'Staff', label: 'Staff' },
            { value: 'Section Head', label: 'Section Head' },
            { value: 'Department Head', label: 'Department Head' },
            { value: 'General Manager', label: 'General Manager' },
            { value: 'Direktur', label: 'Direktur' }
        ],
        unit: [
            { value: 'PT Makassar Jaya Samudera', label: 'PT Makassar Jaya Samudera' },
            { value: 'PT Samudera Makassar Logistik', label: 'PT Samudera Makassar Logistik' },
            { value: 'PT Kendari Jaya Samudera', label: 'PT Kendari Jaya Samudera' },
            { value: 'PT Samudera Kendari Logistik', label: 'PT Samudera Kendari Logistik' },
            { value: 'PT Samudera Agencies Indonesia', label: 'PT Samudera Agencies Indonesia' },
            { value: 'PT SILKargo Indonesia', label: 'PT SILKargo Indonesia' },
            { value: 'PT PAD Samudera Perdana', label: 'PT PAD Samudera Perdana' },
            { value: 'PT Masaji Kargosentra Tama', label: 'PT Masaji Kargosentra Tama' },
            { value: 'Samudera', label: 'Samudera' },
        ],
        department: [
            { value: 'Operation', label: 'Operation' },
            { value: 'Marketing', label: 'Marketing' },
            { value: 'Finance', label: 'Finance' },
            { value: 'GA/Umum', label: 'GA/Umum' },
            { value: 'HC', label: 'HC' },
            { value: 'QHSE', label: 'QHSE' },
            { value: 'VMS', label: 'VMS' },
            { value: 'IT', label: 'IT' },
            { value: 'Panitia', label: 'Panitia' },
        ],
        role: [
            { value: 'Employee', label: 'Employee' },
            { value: 'Validator', label: 'Validator' },
            { value: 'Reviewer', label: 'Reviewer' },
            { value: 'Admin', label: 'Admin' },
            { value: 'Super Admin', label: 'Super Admin' }
        ],
        lokasi: [ // ← TAMBAHKAN INI
            { value: 'Jakarta', label: 'Jakarta' },
            { value: 'Makassar', label: 'Makassar' },
            { value: 'Kendari', label: 'Kendari' },
            { value: 'Surabaya', label: 'Surabaya' },
            { value: 'Medan', label: 'Medan' },
            { value: 'Palopo', label: 'Palopo' },
            { value: 'Malili', label: 'Malili' },
            { value: 'Bitung', label: 'Bitung' }
        ]
    }

    // Fungsi untuk mengambil data dari Firestore
    useEffect(() => {
        const fetchUsers = async () => {
            setLoading(true)
            try {
                const querySnapshot = await getDocs(collection(db, 'users'))
                const usersData = querySnapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data()
                }))

                const sortedUsers = usersData.sort((a, b) => {
                    return (a.nama || '').localeCompare(b.nama || '')
                })
                setUsers(sortedUsers)
            } catch (error) {
                console.error("Error fetching users:", error)
            } finally {
                setLoading(false)
            }
        }

        fetchUsers()
    }, [])

    const handleEdit = (uid) => {
        navigate(`/manage-users/edit?uid=${uid}`)
    }

    const handleDelete = (user) => {
        setDeleteModal({ isOpen: true, user })
    }

    const confirmDelete = async () => {
        if (!deleteModal.user) return
        
        setIsDeleting(true)
        try {
            const userUid = deleteModal.user.uid
            
            const deleteManagedUser = httpsCallable(functions, 'deleteManagedUser')
            await deleteManagedUser({ uid: userUid })
            
            // Update state users
            setUsers(users.filter(u => u.uid !== userUid))
            
            toast.success('Pengguna berhasil dihapus')
            setDeleteModal({ isOpen: false, user: null })
        } catch (error) {
            console.error('Error deleting user:', error)
            toast.error('Gagal menghapus pengguna. Silakan coba lagi')
        } finally {
            setIsDeleting(false)
        }
    }

    const cancelDelete = () => {
        setDeleteModal({ isOpen: false, user: null })
    }

    // Bagian BM: migrasi satu-kali (aman diklik berkali-kali) untuk menyembuhkan
    // LPJ yang salah ditandai "tidak_sesuai" oleh bug lama textContainsAmount
    // (Vision OCR kehilangan separator sen di beberapa bukti transfer bank,
    // sudah diperbaiki -- lihat functions/lib/pengembalianMatcher.js). Teks
    // OCR yang sudah tersimpan dicocokkan ULANG pakai logika baru, TANPA perlu
    // user upload ulang. Lihat backfillPengembalianValidation di functions/index.js.
    const [isBackfillingPengembalian, setIsBackfillingPengembalian] = useState(false)
    const handleBackfillPengembalian = async () => {
        setIsBackfillingPengembalian(true)
        try {
            const backfillPengembalianValidation = httpsCallable(functions, 'backfillPengembalianValidation')
            const result = await backfillPengembalianValidation()
            toast.success(`${result.data?.fixed ?? 0} dari ${result.data?.checked ?? 0} LPJ "tidak_sesuai" diperbaiki jadi "valid"`)
        } catch (error) {
            console.error('Error backfilling pengembalian validation:', error)
            toast.error('Gagal menjalankan ulang validasi bukti pengembalian')
        } finally {
            setIsBackfillingPengembalian(false)
        }
    }

    // Migrasi satu-kali (aman diklik berkali-kali) untuk mengisi /userDirectory
    // dari user LAMA yang sudah ada sebelum trigger syncUserDirectoryOnWrite live
    // -- trigger itu sendiri hanya jalan untuk write BARU ke /users, bukan
    // retroaktif. Lihat backfillUserDirectory di functions/index.js.
    const [isSyncingDirectory, setIsSyncingDirectory] = useState(false)
    const handleSyncDirectory = async () => {
        setIsSyncingDirectory(true)
        try {
            const backfillUserDirectory = httpsCallable(functions, 'backfillUserDirectory')
            const result = await backfillUserDirectory()
            toast.success(`Direktori pengguna disinkronkan (${result.data?.synced ?? 0} pengguna)`)
        } catch (error) {
            console.error('Error syncing user directory:', error)
            toast.error('Gagal menyinkronkan direktori pengguna')
        } finally {
            setIsSyncingDirectory(false)
        }
    }

    // Migrasi satu-kali (aman diklik berkali-kali) untuk mengisi /displayIdOwners
    // dari dokumen bonSementara/reimbursement/lpj LAMA yang sudah ada sebelum
    // koleksi ini diperkenalkan (Bagian K/21.2) -- tanpa ini, pemilik dokumen
    // lama akan gagal permission-denied saat mencetak ulang PDF-nya sendiri
    // (tombol Print di Detail BS/RBS/LPJ, Cetak di ReimbursementTable, Reminder
    // Finance di BsTable). Lihat backfillDisplayIdOwners di functions/index.js.
    const [isSyncingOwnership, setIsSyncingOwnership] = useState(false)
    const handleSyncOwnership = async () => {
        setIsSyncingOwnership(true)
        try {
            const backfillDisplayIdOwners = httpsCallable(functions, 'backfillDisplayIdOwners')
            const result = await backfillDisplayIdOwners()
            toast.success(`Kepemilikan dokumen disinkronkan (${result.data?.synced ?? 0} dokumen)`)
        } catch (error) {
            console.error('Error syncing displayId ownership:', error)
            toast.error('Gagal menyinkronkan kepemilikan dokumen')
        } finally {
            setIsSyncingOwnership(false)
        }
    }

    // Migrasi satu-kali (aman diklik berkali-kali) untuk mengisi custom claim
    // `role` di token Auth semua user LAMA -- trigger syncUserDirectoryOnWrite
    // cuma jalan untuk write BARU ke /users, bukan retroaktif. Tanpa ini,
    // storage.rules (isSuperAdminRole()) menganggap user lama TIDAK punya role
    // apapun di token-nya sampai dokumen /users mereka ditulis ulang. Lihat
    // backfillCustomClaims di functions/index.js.
    const [isSyncingClaims, setIsSyncingClaims] = useState(false)
    const handleSyncClaims = async () => {
        setIsSyncingClaims(true)
        try {
            const backfillCustomClaims = httpsCallable(functions, 'backfillCustomClaims')
            const result = await backfillCustomClaims()
            toast.success(`Role di token disinkronkan (${result.data?.updated ?? 0} user${result.data?.failed ? `, ${result.data.failed} gagal` : ''})`)
        } catch (error) {
            console.error('Error syncing custom claims:', error)
            toast.error('Gagal menyinkronkan role di token')
        } finally {
            setIsSyncingClaims(false)
        }
    }

    // Migrasi darurat SATU KALI (insiden 2026-09-07): sendPengembalianReminders
    // diterapkan retroaktif ke SEMUA LPJ lama yang punya sisaLebih>0, bukan cuma
    // LPJ baru -- run pertama scheduler langsung mengirim email reminder beruntun
    // untuk ratusan LPJ lama sekaligus ("bom email") karena baseline-nya
    // tanggalPengajuan yang sudah lama lewat. Tombol ini menandai LPJ LAMA
    // (cutoff tanggal tetap di kode functions/index.js, BUKAN "sekarang" --
    // supaya aman diklik kapan pun tanpa ikut menghapus reminder LPJ baru yang
    // genuinely belum upload) sebagai selesai TANPA lampiran asli karena bukti
    // lama sudah tidak realistis dicari. Lihat grandfatherPengembalianLpj.
    const [isGrandfatheringPengembalian, setIsGrandfatheringPengembalian] = useState(false)
    const handleGrandfatherPengembalian = async () => {
        setIsGrandfatheringPengembalian(true)
        try {
            const grandfatherPengembalianLpj = httpsCallable(functions, 'grandfatherPengembalianLpj')
            const result = await grandfatherPengembalianLpj()
            toast.success(`${result.data?.updated ?? 0} LPJ lama ditandai selesai, reminder berhenti`)
        } catch (error) {
            console.error('Error grandfathering pengembalian LPJ:', error)
            toast.error('Gagal menandai LPJ lama selesai')
        } finally {
            setIsGrandfatheringPengembalian(false)
        }
    }

    // Fungsi untuk menangani input pencarian
    const handleSearch = (event) => {
        setSearchTerm(event.target.value)
        setCurrentPage(1) // Reset ke halaman pertama saat melakukan pencarian
    }

    const handleFilterChange = (field, selectedOption) => {
        setFilters((prev) => ({
            ...prev,
            [field]: selectedOption
        }))
        setCurrentPage(1)
    }

    const resetFilters = () => {
        setFilters({
            posisi: '',
            unit: '',
            role: '',
            department: '',
            lokasi: ''
        })
        setSearchTerm('')
        setCurrentPage(1)
    }

    // Filter data pengguna berdasarkan nilai pencarian dan filter
    const filteredUsers = users.filter((user) => {
        const searchTermLower = searchTerm.toLowerCase()
        const matchesSearch =
            user.nama?.toLowerCase().includes(searchTermLower) || user.email?.toLowerCase().includes(searchTermLower)

        const matchesFilters = Object.entries(filters).every(([field, selectedOption]) => {
            if (!selectedOption) return true
            if (field === 'department' && Array.isArray(user[field])) {
                return user[field].includes(selectedOption.value)
            }
            return user[field] === selectedOption.value
        })
        return matchesSearch && matchesFilters
        // // Menyaring pengguna dengan role 'Super Admin' agar tidak ditampilkan
        // return matchesSearch && matchesFilters && user.role !== 'Super Admin'
    })

    // Menghitung total halaman
    const totalPages = Math.ceil(filteredUsers.length / itemsPerPage)

    // Mendapatkan data pengguna untuk halaman saat ini
    const currentUsers = filteredUsers.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)

    // Fungsi untuk berpindah ke halaman berikutnya
    const nextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1)
        }
    }

    // Fungsi untuk berpindah ke halaman sebelumnya
    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1)
        }
    }

    const selectStyles = {
        control: (base) => ({
            ...base,
            backgroundColor: isDark ? '#1f2937' : '#ffffff',
            borderColor: isDark ? '#4b5563' : '#e5e7eb',
            '&:hover': {
                borderColor: '#3b82f6'
            },
            minHeight: '32px',
            fontSize: '14px',
            display: 'flex',
            flexWrap: 'nowrap',
            overflow: 'auto'
        }),
        valueContainer: (base) => ({
            ...base,
            flexWrap: 'nowrap',
            whiteSpace: 'nowrap',
            overflow: 'auto',
            '::-webkit-scrollbar': {
                display: 'none'
            },
            scrollbarWidth: 'none'
        }),
        singleValue: (base) => ({
            ...base,
            color: isDark ? '#f3f4f6' : '#111827'
        }),
        input: (base) => ({
            ...base,
            color: isDark ? '#f3f4f6' : '#111827'
        }),
        placeholder: (base) => ({
            ...base,
            color: isDark ? '#9ca3af' : '#6b7280'
        }),
        menu: (base) => ({
            ...base,
            backgroundColor: isDark ? '#1f2937' : '#ffffff',
            zIndex: 100
        }),
        // Bagian AX: menuPortalTarget={document.body} butuh z-index tinggi di
        // sini juga (bukan cuma di `menu`) supaya dropdown tidak tampil
        // tertutup/salah posisi kalau Select ini dirender di dalam modal lain.
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isFocused
                ? (isDark ? '#374151' : '#f3f4f6')
                : (isDark ? '#1f2937' : '#ffffff'),
            color: isDark ? '#f3f4f6' : '#111827',
            fontSize: '14px',
            padding: '6px 12px',
            cursor: 'pointer'
        }),
        multiValue: (base) => ({
            ...base,
            backgroundColor: isDark ? '#374151' : '#e5e7eb',
            fontSize: '14px',
            flexShrink: 0
        }),
        multiValueLabel: (base) => ({
            ...base,
            color: isDark ? '#f3f4f6' : '#111827'
        })
    }

    const FilterSelect = ({ field, label }) => (
        <Select
            value={filters[field]}
            onChange={(option) => handleFilterChange(field, option)}
            options={filterOptions[field]}
            placeholder={label}
            isClearable
            className="w-full"
            styles={selectStyles}
            isSearchable={false}
            menuPortalTarget={document.body}
            menuPosition="absolute"
        />
    )

    return (
        <div className="container mx-auto py-10 md:py-8">
            <div className="flex flex-wrap items-center justify-between gap-4 mb-4">
                <h2 className="text-xl font-bold dark:text-gray-100">Manage Users</h2>
                <div className="flex flex-wrap gap-2">
                    <button
                        onClick={handleBackfillPengembalian}
                        disabled={isBackfillingPengembalian}
                        title="Cocokkan ulang bukti pengembalian LPJ berstatus 'tidak_sesuai' pakai logika OCR terbaru -- aman diklik berkali-kali"
                        className="px-4 py-2 text-sm bg-gray-100 text-gray-700 rounded hover:bg-gray-200 disabled:opacity-50 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600 flex-none"
                    >
                        {isBackfillingPengembalian ? 'Memvalidasi ulang...' : 'Validasi Ulang Bukti Pengembalian'}
                    </button>
                    <button
                        onClick={handleSyncDirectory}
                        disabled={isSyncingDirectory}
                        title="Isi ulang /userDirectory dari data /users -- jalankan sekali setelah deploy fitur ini, aman diklik berkali-kali"
                        className="px-4 py-2 text-sm bg-gray-100 text-gray-700 rounded hover:bg-gray-200 disabled:opacity-50 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600 flex-none"
                    >
                        {isSyncingDirectory ? 'Menyinkronkan...' : 'Sinkronkan Direktori Pengguna'}
                    </button>
                    <button
                        onClick={handleSyncOwnership}
                        disabled={isSyncingOwnership}
                        title="Isi ulang /displayIdOwners dari dokumen BS/RBS/LPJ lama -- jalankan sekali setelah deploy fitur ini, aman diklik berkali-kali"
                        className="px-4 py-2 text-sm bg-gray-100 text-gray-700 rounded hover:bg-gray-200 disabled:opacity-50 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600 flex-none"
                    >
                        {isSyncingOwnership ? 'Menyinkronkan...' : 'Sinkronkan Kepemilikan Dokumen'}
                    </button>
                    <button
                        onClick={handleSyncClaims}
                        disabled={isSyncingClaims}
                        title="Isi ulang custom claim role di token Auth dari data /users -- jalankan sekali setelah deploy fitur ini, aman diklik berkali-kali"
                        className="px-4 py-2 text-sm bg-gray-100 text-gray-700 rounded hover:bg-gray-200 disabled:opacity-50 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600 flex-none"
                    >
                        {isSyncingClaims ? 'Menyinkronkan...' : 'Sinkronkan Role Token'}
                    </button>
                    <button
                        onClick={handleGrandfatherPengembalian}
                        disabled={isGrandfatheringPengembalian}
                        title="Tandai selesai LPJ lama (sisaLebih>0, diajukan sebelum fitur validasi pengembalian aktif) supaya reminder email berhenti -- klik SEKARANG untuk stop bom email"
                        className="px-4 py-2 text-sm bg-red-100 text-red-700 rounded hover:bg-red-200 disabled:opacity-50 dark:bg-red-900/40 dark:text-red-300 dark:hover:bg-red-900/60 flex-none"
                    >
                        {isGrandfatheringPengembalian ? 'Memproses...' : 'Selesaikan LPJ Lama (Pengembalian)'}
                    </button>
                </div>
            </div>

            <div className="bg-white p-6 rounded-lg mb-6 shadow-sm dark:bg-gray-800">
                <h3 className="text-xl font-medium mb-4 dark:text-gray-100">Daftar Pengguna</h3>

                {/* Desktop Layout */}
                <div className="hidden xl:flex text-sm items-center gap-2 mb-4">
                    {loading ? (
                        <>
                            <div className="flex-1"><Skeleton height={32} width={190} /></div>
                            <div className="w-full"><Skeleton height={32} /></div>
                            <div className="w-full"><Skeleton height={32} /></div>
                            <div className="w-full"><Skeleton height={32} /></div>
                            <div className="w-full"><Skeleton height={32} /></div>
                            <div className="w-full"><Skeleton height={32} /></div>
                            <div className="w-full"><Skeleton height={32} /></div>
                        </>
                    ) : (
                        <>
                            <input
                                type="text"
                                placeholder="Cari pengguna..."
                                value={searchTerm}
                                onChange={handleSearch}
                                className="flex-1 px-4 py-2 border rounded-md hover:border-blue-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100 dark:placeholder-gray-400"
                            />
                            <FilterSelect field="posisi" label="Posisi" />
                            <FilterSelect field="unit" label="Unit Bisnis" />
                            <FilterSelect field="role" label="Role" />
                            <FilterSelect field="department" label="Department" />
                            <FilterSelect field="lokasi" label="Lokasi" />

                            <button
                                onClick={resetFilters}
                                className="px-4 py-2.5 bg-gray-100 text-gray-700 rounded hover:bg-gray-200 flex-none dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600"
                            >
                                Reset Filter
                            </button>
                            <Link to="/manage-users/add">
                                <button className="px-8 py-2.5 bg-red-600 text-white rounded hover:bg-red-700 hover:text-gray-200 w-max">
                                    Tambah Data
                                </button>
                            </Link>
                        </>
                    )}
                </div>

                {/* Tablet Layout */}
                <div className="hidden sm:flex xl:hidden flex-col gap-4">
                    {loading ? (
                        <>
                            <div className="flex flex-row items-start gap-2">
                                <div className="flex-1">
                                    <Skeleton height={32} />
                                </div>
                                <div className="flex flex-row gap-2">
                                    <div><Skeleton height={32} width={120} /></div>
                                    <div><Skeleton height={32} width={120} /></div>
                                </div>
                            </div>
                            <div className="grid grid-cols-4 gap-2 w-full mb-4">
                                <div className="w-full"><Skeleton height={32} /></div>
                                <div className="w-full"><Skeleton height={32} /></div>
                                <div className="w-full"><Skeleton height={32} /></div>
                                <div className="w-full"><Skeleton height={32} /></div>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="flex flex-row items-start gap-4">
                                <input
                                    type="text"
                                    placeholder="Cari pengguna..."
                                    value={searchTerm}
                                    onChange={handleSearch}
                                    className="flex-1 px-4 py-2 border rounded-md hover:border-blue-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100 dark:placeholder-gray-400"
                                />

                                <div className="flex flex-row gap-2">
                                    <button
                                        onClick={resetFilters}
                                        className="px-4 py-2.5 bg-gray-100 text-gray-700 rounded hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600"
                                    >
                                        Reset Filter
                                    </button>

                                    <Link to="/manage-users/add">
                                        <button className="px-8 py-2.5 bg-red-600 text-white rounded hover:bg-red-700 hover:text-gray-200">
                                            Tambah Data
                                        </button>
                                    </Link>
                                </div>
                            </div>

                            <div className="grid grid-cols-5 gap-4 w-full mb-4">
                                <FilterSelect field="posisi" label="Posisi" />
                                <FilterSelect field="unit" label="Unit Bisnis" />
                                <FilterSelect field="role" label="Role" />
                                <FilterSelect field="department" label="Department" />
                                <FilterSelect field="lokasi" label="Lokasi" />
                            </div>
                        </>
                    )}
                </div>

                {/* Mobile Layout */}
                <div className="flex sm:hidden flex-col gap-4">
                    {loading ? (
                        <>
                            <div className="flex flex-col gap-4">
                                <div>
                                    <Skeleton height={32} />
                                </div>

                                <div className="flex flex-col gap-4">
                                    <div>
                                        <Skeleton height={32} />
                                    </div>

                                    <div>
                                        <Skeleton height={32} />
                                    </div>
                                </div>
                            </div>
                            <div className="grid grid-cols-2 gap-4 w-full mb-4">
                                <div className="w-full"><Skeleton height={32} /></div>
                                <div className="w-full"><Skeleton height={32} /></div>
                                <div className="w-full"><Skeleton height={32} /></div>
                                <div className="w-full"><Skeleton height={32} /></div>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="flex flex-col gap-4">
                                <input
                                    type="text"
                                    placeholder="Cari pengguna..."
                                    value={searchTerm}
                                    onChange={handleSearch}
                                    className="w-full px-4 py-2 border rounded-md hover:border-blue-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 focus:outline-none text-xs dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100 dark:placeholder-gray-400"
                                />

                                <div className="flex flex-col gap-4">
                                    <Link to="/manage-users/add" className="w-full">
                                        <button className="w-full px-8 py-2.5 bg-red-600 text-white rounded hover:bg-red-700 hover:text-gray-200">
                                            Tambah Data
                                        </button>
                                    </Link>

                                    <button
                                        onClick={resetFilters}
                                        className="w-full px-4 py-2.5 bg-gray-100 text-gray-700 rounded hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600"
                                    >
                                        Reset Filter
                                    </button>
                                </div>
                            </div>

                            <div className="grid grid-cols-2 gap-4 w-full mb-4">
                                <FilterSelect field="posisi" label="Posisi" />
                                <FilterSelect field="unit" label="Unit Bisnis" />
                                <FilterSelect field="role" label="Role" />
                                <FilterSelect field="department" label="Department" />
                                <FilterSelect field="lokasi" label="Lokasi" />
                            </div>
                        </>
                    )}

                    
                </div>

                {loading ? (
                    <Skeleton count={5} height={40} />
                ) : (
                    <>
                        <div className="w-full">
                            <div className="w-full overflow-x-auto">
                                <div className="inline-block min-w-[1000px] w-full">
                                    <table className="min-w-full bg-white border rounded-lg text-sm dark:bg-gray-800 dark:border-gray-600">
                                        <thead>
                                            <tr className="bg-gray-100 text-left dark:bg-gray-700">
                                                <th className="px-2 py-2 border text-center w-auto dark:border-gray-600">No.</th>
                                                <th className="px-4 py-2 border break-words dark:border-gray-600">Nama</th>
                                                <th className="px-4 py-2 border break-words dark:border-gray-600">Email</th>
                                                <th className="px-4 py-2 border break-words dark:border-gray-600">Posisi</th>
                                                <th className="px-4 py-2 border break-words dark:border-gray-600">Unit Bisnis</th>
                                                <th className="px-4 py-2 border break-words dark:border-gray-600">Lokasi</th>
                                                <th className="px-4 py-2 border break-words dark:border-gray-600">Role</th>
                                                <th className="px-4 py-2 border break-words dark:border-gray-600">Department</th>
                                                <th className="px-2 py-2 border text-center dark:border-gray-600">Aksi</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentUsers.map((user, index) => (
                                                <tr key={user.id}>
                                                    <td className="px-2 py-2 border text-center w-auto dark:border-gray-600">
                                                        {index + 1 + (currentPage - 1) * itemsPerPage}
                                                    </td>
                                                    <td className="px-4 py-2 border dark:border-gray-600">{user.nama}</td>
                                                    <td className="px-4 py-2 border dark:border-gray-600">{user.email}</td>
                                                    <td className="px-4 py-2 border dark:border-gray-600">{user.posisi}</td>
                                                    <td className="px-4 py-2 border dark:border-gray-600">{user.unit}</td>
                                                    <td className="px-4 py-2 border dark:border-gray-600">{user.lokasi}</td>
                                                    <td className="px-4 py-2 border dark:border-gray-600">{user.role}</td>
                                                    <td className="px-4 py-2 border dark:border-gray-600">
                                                        {Array.isArray(user.department)
                                                            ? user.department.join(', ')
                                                            : user.department}
                                                    </td>
                                                    <td className="px-2 py-2 border text-center dark:border-gray-600">
                                                        <div className="flex justify-center space-x-2">
                                                            <button
                                                                onClick={() => handleEdit(user.uid)}
                                                                className="flex items-center justify-center rounded-full p-1 bg-green-200 hover:bg-green-300 text-green-600 border-[1px] border-green-600"
                                                                title="Edit"
                                                            >
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    viewBox="0 0 20 20"
                                                                    fill="currentColor"
                                                                    className="size-5"
                                                                >
                                                                    <path d="m5.433 13.917 1.262-3.155A4 4 0 0 1 7.58 9.42l6.92-6.918a2.121 2.121 0 0 1 3 3l-6.92 6.918c-.383.383-.84.685-1.343.886l-3.154 1.262a.5.5 0 0 1-.65-.65Z" />
                                                                    <path d="M3.5 5.75c0-.69.56-1.25 1.25-1.25H10A.75.75 0 0 0 10 3H4.75A2.75 2.75 0 0 0 2 5.75v9.5A2.75 2.75 0 0 0 4.75 18h9.5A2.75 2.75 0 0 0 17 15.25V10a.75.75 0 0 0-1.5 0v5.25c0 .69-.56 1.25-1.25 1.25h-9.5c-.69 0-1.25-.56-1.25-1.25v-9.5Z" />
                                                                </svg>
                                                            </button>

                                                            {/* Tombol Delete */}
                                                            <button
                                                                onClick={() => handleDelete(user)}
                                                                className="flex items-center justify-center rounded-full p-1 bg-red-200 hover:bg-red-300 text-red-600 border-[1px] border-red-600"
                                                                title="Delete"
                                                            >
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    viewBox="0 0 20 20"
                                                                    fill="currentColor"
                                                                    className="size-5"
                                                                >
                                                                    <path
                                                                        fillRule="evenodd"
                                                                        d="M8.75 1A2.75 2.75 0 0 0 6 3.75v.443c-.795.077-1.584.176-2.365.298a.75.75 0 1 0 .23 1.482l.149-.022.841 10.518A2.75 2.75 0 0 0 7.596 19h4.807a2.75 2.75 0 0 0 2.742-2.53l.841-10.52.149.023a.75.75 0 0 0 .23-1.482A41.03 41.03 0 0 0 14 4.193V3.75A2.75 2.75 0 0 0 11.25 1h-2.5ZM10 4c.84 0 1.673.025 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325C8.327 4.025 9.16 4 10 4ZM8.58 7.72a.75.75 0 0 0-1.5.06l.3 7.5a.75.75 0 1 0 1.5-.06l-.3-7.5Zm4.34.06a.75.75 0 1 0-1.5-.06l-.3 7.5a.75.75 0 1 0 1.5.06l.3-7.5Z"
                                                                        clipRule="evenodd"
                                                                    />
                                                                </svg>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </>
                )}
                {/* Pagination Controls dengan Ellipsis - Mobile Friendly */}
                {totalPages > 1 && (
                    <div className="flex items-center justify-center gap-1 mt-6 text-xs">
                        {/* Tombol Previous */}
                        <button
                            onClick={prevPage}
                            disabled={currentPage === 1}
                            className={`flex items-center px-2 h-9 rounded-full ${
                                currentPage === 1
                                    ? 'bg-gray-200 text-gray-500 cursor-not-allowed dark:bg-gray-700 dark:text-gray-400'
                                    : 'border border-red-600 text-red-600 hover:bg-red-100 dark:border-red-500 dark:text-red-400 dark:hover:bg-red-900/30'
                            }`}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth={1.5}
                                stroke="currentColor"
                                className="size-4"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                            </svg>
                        </button>

                        {/* Tombol Halaman dengan Ellipsis */}
                        {(() => {
                            let pages = []
                            // Mengurangi jumlah halaman yang ditampilkan di mobile
                            const visiblePages = window.innerWidth < 640 ? 1 : 3

                            // Selalu tampilkan halaman pertama
                            pages.push(
                                <button
                                    key={1}
                                    onClick={() => setCurrentPage(1)}
                                    className={`min-w-[36px] h-9 rounded-full ${
                                        currentPage === 1
                                            ? 'bg-red-600 text-white'
                                            : 'border border-red-600 text-red-600 hover:bg-red-100 dark:border-red-500 dark:text-red-400 dark:hover:bg-red-900/30'
                                    }`}
                                >
                                    1
                                </button>
                            )

                            if (totalPages <= visiblePages + 2) {
                                // Jika total halaman sedikit, tampilkan semua
                                for (let i = 2; i <= totalPages; i++) {
                                    pages.push(
                                        <button
                                            key={i}
                                            onClick={() => setCurrentPage(i)}
                                            className={`min-w-[36px] h-9 rounded-full ${
                                                currentPage === i
                                                    ? 'bg-red-600 text-white'
                                                    : 'border border-red-600 text-red-600 hover:bg-red-100 dark:border-red-500 dark:text-red-400 dark:hover:bg-red-900/30'
                                            }`}
                                        >
                                            {i}
                                        </button>
                                    )
                                }
                            } else {
                                // Logika untuk mobile view
                                if (window.innerWidth < 640) {
                                    // Jika current page bukan di awal atau akhir, tampilkan ellipsis di kedua sisi
                                    if (currentPage > 2 && currentPage < totalPages - 1) {
                                        pages.push(
                                            <span key="ellipsis1" className="px-1">
                                                ...
                                            </span>
                                        )
                                        pages.push(
                                            <button
                                                key={currentPage}
                                                onClick={() => setCurrentPage(currentPage)}
                                                className="min-w-[36px] h-9 rounded-full bg-red-600 text-white"
                                            >
                                                {currentPage}
                                            </button>
                                        )
                                        pages.push(
                                            <span key="ellipsis2" className="px-1">
                                                ...
                                            </span>
                                        )
                                    } else if (currentPage <= 2) {
                                        // Tampilkan halaman 2 jika current page di awal
                                        if (currentPage === 2) {
                                            pages.push(
                                                <button
                                                    key={2}
                                                    onClick={() => setCurrentPage(2)}
                                                    className="min-w-[36px] h-9 rounded-full bg-red-600 text-white"
                                                >
                                                    2
                                                </button>
                                            )
                                        }
                                        pages.push(
                                            <span key="ellipsis1" className="px-1">
                                                ...
                                            </span>
                                        )
                                    } else {
                                        // Tampilkan ellipsis dan halaman sebelum terakhir jika di akhir
                                        pages.push(
                                            <span key="ellipsis1" className="px-1">
                                                ...
                                            </span>
                                        )
                                        if (currentPage === totalPages - 1) {
                                            pages.push(
                                                <button
                                                    key={totalPages - 1}
                                                    onClick={() => setCurrentPage(totalPages - 1)}
                                                    className="min-w-[36px] h-9 rounded-full bg-red-600 text-white"
                                                >
                                                    {totalPages - 1}
                                                </button>
                                            )
                                        }
                                    }
                                } else {
                                    // Desktop view logic
                                    if (currentPage <= visiblePages) {
                                        for (let i = 2; i <= visiblePages; i++) {
                                            pages.push(
                                                <button
                                                    key={i}
                                                    onClick={() => setCurrentPage(i)}
                                                    className={`min-w-[36px] h-9 rounded-full ${
                                                        currentPage === i
                                                            ? 'bg-red-600 text-white'
                                                            : 'border border-red-600 text-red-600 hover:bg-red-100 dark:border-red-500 dark:text-red-400 dark:hover:bg-red-900/30'
                                                    }`}
                                                >
                                                    {i}
                                                </button>
                                            )
                                        }
                                        pages.push(
                                            <span key="ellipsis1" className="px-1">
                                                ...
                                            </span>
                                        )
                                    } else if (currentPage > totalPages - visiblePages) {
                                        pages.push(
                                            <span key="ellipsis1" className="px-1">
                                                ...
                                            </span>
                                        )
                                        for (let i = totalPages - visiblePages + 1; i < totalPages; i++) {
                                            pages.push(
                                                <button
                                                    key={i}
                                                    onClick={() => setCurrentPage(i)}
                                                    className={`min-w-[36px] h-9 rounded-full ${
                                                        currentPage === i
                                                            ? 'bg-red-600 text-white'
                                                            : 'border border-red-600 text-red-600 hover:bg-red-100 dark:border-red-500 dark:text-red-400 dark:hover:bg-red-900/30'
                                                    }`}
                                                >
                                                    {i}
                                                </button>
                                            )
                                        }
                                    } else {
                                        pages.push(
                                            <span key="ellipsis1" className="px-1">
                                                ...
                                            </span>
                                        )
                                        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
                                            if (i > 1 && i < totalPages) {
                                                pages.push(
                                                    <button
                                                        key={i}
                                                        onClick={() => setCurrentPage(i)}
                                                        className={`min-w-[36px] h-9 rounded-full ${
                                                            currentPage === i
                                                                ? 'bg-red-600 text-white'
                                                                : 'border border-red-600 text-red-600 hover:bg-red-100 dark:border-red-500 dark:text-red-400 dark:hover:bg-red-900/30'
                                                        }`}
                                                    >
                                                        {i}
                                                    </button>
                                                )
                                            }
                                        }
                                        pages.push(
                                            <span key="ellipsis2" className="px-1">
                                                ...
                                            </span>
                                        )
                                    }
                                }

                                // Selalu tampilkan halaman terakhir
                                if (totalPages > 1) {
                                    pages.push(
                                        <button
                                            key={totalPages}
                                            onClick={() => setCurrentPage(totalPages)}
                                            className={`min-w-[36px] h-9 rounded-full ${
                                                currentPage === totalPages
                                                    ? 'bg-red-600 text-white'
                                                    : 'border border-red-600 text-red-600 hover:bg-red-100 dark:border-red-500 dark:text-red-400 dark:hover:bg-red-900/30'
                                            }`}
                                        >
                                            {totalPages}
                                        </button>
                                    )
                                }
                            }

                            return pages
                        })()}

                        {/* Tombol Next */}
                        <button
                            onClick={nextPage}
                            disabled={currentPage === totalPages}
                            className={`flex items-center px-2 h-9 rounded-full ${
                                currentPage === totalPages
                                    ? 'bg-gray-200 text-gray-500 cursor-not-allowed dark:bg-gray-700 dark:text-gray-400'
                                    : 'border border-red-600 text-red-600 hover:bg-red-100 dark:border-red-500 dark:text-red-400 dark:hover:bg-red-900/30'
                            }`}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth={1.5}
                                stroke="currentColor"
                                className="size-4"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                            </svg>
                        </button>
                    </div>
                )}
            </div>
            {/* Modal Konfirmasi Delete */}
            {deleteModal.isOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
                    <div className="bg-white rounded-lg p-6 max-w-md w-full dark:bg-gray-800">
                        <h3 className="text-lg font-semibold mb-4 dark:text-gray-100">Konfirmasi Hapus</h3>
                        <p className="text-gray-600 mb-6 dark:text-gray-300">
                            Apakah Anda yakin ingin menghapus pengguna{' '}
                            <span className="font-semibold dark:text-gray-100">{deleteModal.user?.nama}</span>?
                            <br />
                            <span className="text-sm text-red-600 mt-2 block dark:text-red-400">
                                Tindakan ini tidak dapat dibatalkan.
                            </span>
                        </p>
                        <div className="flex justify-end gap-3">
                            <button
                                onClick={cancelDelete}
                                disabled={isDeleting}
                                className="px-6 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300 disabled:opacity-50 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600"
                            >
                                Batal
                            </button>
                            <button
                                onClick={confirmDelete}
                                disabled={isDeleting}
                                className="px-6 py-2 bg-red-600 text-white rounded hover:bg-red-700 disabled:opacity-50"
                            >
                                {isDeleting ? 'Menghapus...' : 'Hapus'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default ManageUser